import { render, staticRenderFns } from "./InsolvencyFileImport.vue?vue&type=template&id=495fc676&scoped=true&"
import script from "./InsolvencyFileImport.vue?vue&type=script&lang=js&"
export * from "./InsolvencyFileImport.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyFileImport.vue?vue&type=style&index=0&id=495fc676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fc676",
  null
  
)

export default component.exports